class Envelop {
    constructor(frais, montantEstime, montantReel, ecart) {
        this.frais = frais || '';
        this.montantEstime = montantEstime || 0;
        this.montantReel   = montantReel   || 0;
        this.ecart         = ecart         || 0;
    }
}

export default Envelop;
